import React from 'react';
import {
    TopToolbar,
    sanitizeListRestProps,
    useListContext,
} from 'react-admin';
import { SyncEntityButton } from 'components/toolbars/SyncEntityButton';
import { SyncEntities } from 'entities/SyncEntities';

export const ExternalTerminalLinkActions = (props) => {
    const { className, exporter, filters, ...rest } = props;
    const {
        resource,
        displayedFilters,
        filterValues,
        showFilter,
    } = useListContext(props);

    return React.useMemo(
        () => (
            <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
                <SyncEntityButton 
                    syncEntityId={SyncEntities.external_terminals_links}
                    title='resources.external-terminal-links.buttons.sync'
                />

                {filters &&
                    React.cloneElement(filters, {
                        resource,
                        showFilter,
                        displayedFilters,
                        filterValues,
                        context: 'button',
                    })}
            </TopToolbar>
        ),
        [resource, displayedFilters, filterValues, filters] // eslint-disable-line react-hooks/exhaustive-deps
    );
}
